import { ClockIcon, MailIcon } from '../../../../utils/SVGIcon';
import { useBasicSetting } from '../BasicSettingProvider';
import BasicInfoCard from './BasicInfoCard';
import BasicInfoSmtp from './BasicInfoSmtp';
import ServiceConfigCard from './ServiceConfigCard';

function BasicInfoEditableArea() {
    const { formData } = useBasicSetting();

    return (
        <div className="flex flex-col gap-5 mb-5">
            <BasicInfoCard
                title="Duration of Login Season (Minutes)"
                name="loginSessionDuration"
                formData={formData}
                type="login-session-duration"
                icon={<ClockIcon />}
            />
            <BasicInfoCard
                title="GitHub PAT"
                name="gitHubPatToken"
                formData={formData}
                type="git-hub-pat-token"
                icon={<ClockIcon />}
            />

            <BasicInfoSmtp
                title="SMTP Configuration"
                name="smtpConfig"
                formData={formData}
                type="smtp-config"
                icon={<MailIcon />}
            />
            <ServiceConfigCard title="Service activity process configuration" onClick={null} />
        </div>
    );
}

export default BasicInfoEditableArea;
